const ORDER_STATUS_COLORS: {[key: string]: string} = {
  'status_order_new':                    'blue lighten-4',
  'status_awaiting_customer_dropoff':    'blue lighten-4',
  'status_order_awaiting_collect':       'amber lighten-3',
  'status_order_sp_collected':           'cyan lighten-3',
  'status_order_in_progress':            'light-blue lighten-3',
  'status_order_assembled':              'teal lighten-4',
  'status_order_in_route_collect':       'orange lighten-3',
  'status_order_in_route_delivery':      'deep-orange lighten-3',
  'status_order_sp_delivered':           'light-green lighten-3',
  'status_order_completed':              'green lighten-3',
  'status_order_sp_cancelled':           'red lighten-4',
  'status_order_client_cancelled':       'red lighten-4',
  'status_order_sp_rejected':            'pink lighten-4',
  'status_order_delayed':                'yellow lighten-3',
  'status_order_professional_search':    'purple lighten-4',
  'status_order_professional_confirmed': 'indigo lighten-4',
};

export function orderStatusColor(status: string): string {
  return ORDER_STATUS_COLORS[status] || 'grey lighten-3';
}
